var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import BarLoader from 'react-spinners/BarLoader';
import ClipLoader from 'react-spinners/ClipLoader';
import { useIntl } from 'Intl';
var LoadingContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  flex: 1;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  flex: 1;\n  height: 100%;\n"])), function (props) { return (props.lightText ? 'white' : 'inherit'); });
var Loading = function (_a) {
    var _b = _a.lightText, lightText = _b === void 0 ? false : _b, _c = _a.barColor, barColor = _c === void 0 ? '#ffffff' : _c, _d = _a.includeText, includeText = _d === void 0 ? true : _d, _e = _a.type, type = _e === void 0 ? 'bar' : _e;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(LoadingContainer, { lightText: lightText },
        includeText && formatMessage('common.loading'),
        type === 'spinner' ? (React.createElement(ClipLoader, { color: barColor, size: 35 })) : (React.createElement(BarLoader, { color: barColor }))));
};
export default Loading;
var templateObject_1;
